import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NlrpValidationResultService {
    constructor(private http: HttpClient) {}

    getValidationsReport(url: string): Observable<ArrayBuffer> {
        return this.http.get(url, {responseType: 'arraybuffer'});
    }
}
